import * as React from "react";
import japanese from "japanese";
import {Util} from "../../Util";
import {Icon} from "semantic-ui-react";
import {AudioButton} from "./AudioButton";
import styled from "styled-components";

interface IProps {
    character: string,
    showLanguageError: { (): void }
}

interface IState {
}

export class CharacterExplanation extends React.Component<IProps, IState> {
    public render() {
        let explanation: JSX.Element;
        switch (this.props.character) {
            case 'ッ':
                explanation = (
                    <div>
                        <p>This new character is called <i>sokuon</i>. It looks like a smaller version of
                            the <i>tsu</i> we
                            learned earlier. However, the sokuon doesn't have a pronunciation on its own, but
                            instead doubles the consonant that follow</p>
                        <p>In the romanji transcription we thus reflect this by writing the consonant that follows the
                            sokuon twice.</p>
                    </div>
                )
                break;
            case 'っ':
                explanation = (<div>
                    <p>This new character is called <i>sokuon</i>. It looks like a smaller version of the <i>tsu</i> we
                        learned earlier. However, the sokuon doesn't have a pronunciation on its own, but
                        instead doubles the consonant that follow</p>
                    <p>In the romanji transcription we thus reflect this by writing the consonant that follows the
                        sokuon twice.</p>
                </div>)
                break;
            case 'ャ':
                explanation = (<div>
                    <p>This character looks like a smaller version of the ヤ (<i>ya</i>).</p>
                    <p>The ヤ (<i>ya</i>) sound gets combined with the preceding sound. It only ever follows sounds
                        ending in <i>i</i></p>
                    <p>This allows for the following combinations:
                        <table>
                            <tr>
                                <td>キャ</td>
                                <td><i>kya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('キャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>シャ</td>
                                <td><i>sha</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('シャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>チャ</td>
                                <td><i>cha</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('チャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ニャ</td>
                                <td><i>nya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ニャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ヒャ</td>
                                <td><i>hya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ヒャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ミャ</td>
                                <td><i>mya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ミャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>リャ</td>
                                <td><i>rya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('リャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ギャ</td>
                                <td><i>gya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ギャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ジャ</td>
                                <td><i>ja</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ジャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ビャ</td>
                                <td><i>bya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ビャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ピャ</td>
                                <td><i>pya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ピャ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                        </table>
                    </p>
                </div>)
                break;
            case 'ュ':
                explanation = (<div>
                    <p>This character looks like a smaller version of the ユ (<i>yu</i>).</p>
                    <p>The ユ (<i>yu</i>) sound gets combined with the preceding sound. It only ever follows sounds
                        ending in <i>i</i></p>
                    <p>This allows for the following combinations:
                        <table>
                            <tr>
                                <td>キュ</td>
                                <td><i>kyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('キュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>シュ</td>
                                <td><i>shu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('シュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            ユ
                            <tr>
                                <td>チュ</td>
                                <td><i>chu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('チュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ニュ</td>
                                <td><i>nyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ニュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ヒュ</td>
                                <td><i>hyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ヒュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ミュ</td>
                                <td><i>myu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ミュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>リュ</td>
                                <td><i>ryu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('リュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ギュ</td>
                                <td><i>gyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ギュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ジュ</td>
                                <td><i>ja</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ジュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ビュ</td>
                                <td><i>byu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ビュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ピュ</td>
                                <td><i>pyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ピュ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                        </table>
                    </p>
                </div>)
                break;
            case 'ョ':
                explanation = (<div>
                    <p>This character looks like a smaller version of the ヨ (<i>yo</i>).</p>
                    <p>The ヨ (<i>yo</i>) sound gets combined with the preceding sound. It only ever follows sounds
                        ending in <i>i</i></p>
                    <p>This allows for the following combinations:
                        <table>
                            <tr>
                                <td>キョ</td>
                                <td><i>kyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('キョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ショ</td>
                                <td><i>sho</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ショ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>チョ</td>
                                <td><i>cho</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('チョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ニョ</td>
                                <td><i>nyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ニョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ヒョ</td>
                                <td><i>hyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ヒョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ミョ</td>
                                <td><i>myo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ミョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>リョ</td>
                                <td><i>ryo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('リョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ギョ</td>
                                <td><i>gyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ギョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ジョ</td>
                                <td><i>ja</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ジョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ビョ</td>
                                <td><i>byo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ビョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ピョ</td>
                                <td><i>pyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ピョ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                        </table>
                    </p>
                </div>)
                break;
            case 'ゃ':
                explanation = (<div>
                    <p>This character looks like a smaller version of the や (<i>ya</i>).</p>
                    <p>The や (<i>ya</i>) sound gets combined with the preceding sound. It only ever follows sounds
                        ending in <i>i</i></p>
                    <p>This allows for the following combinations:
                        <table>
                            <tr>
                                <td>きゃ</td>
                                <td><i>kya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('きゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>しゃ</td>
                                <td><i>sha</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('しゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ちゃ</td>
                                <td><i>cha</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ちゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>にゃ</td>
                                <td><i>nya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('にゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ひゃ</td>
                                <td><i>hya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ひゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>みゃ</td>
                                <td><i>mya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('みゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>りゃ</td>
                                <td><i>rya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('りゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ぎゃ</td>
                                <td><i>gya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ぎゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>じゃ</td>
                                <td><i>ja</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('じゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>びゃ</td>
                                <td><i>bya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('びゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ぴゃ</td>
                                <td><i>pya</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ぴゃ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                        </table>
                    </p>
                </div>)
                break;
            case 'ゅ':
                explanation = (<div>
                    <p>This character looks like a smaller version of the ゆ (<i>yu</i>).</p>
                    <p>The ゆ (<i>yu</i>) sound gets combined with the preceding sound. It only ever follows sounds
                        ending in <i>i</i></p>
                    <p>This allows for the following combinations:
                        <table>
                            <tr>
                                <td>きゅ</td>
                                <td><i>kyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('きゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>しゅ</td>
                                <td><i>shu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('しゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ちゅ</td>
                                <td><i>chu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ちゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>にゅ</td>
                                <td><i>nyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('にゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ひゅ</td>
                                <td><i>hyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ひゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>みゅ</td>
                                <td><i>myu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('みゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>りゅ</td>
                                <td><i>ryu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('りゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ぎゅ</td>
                                <td><i>gyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ぎゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>じゅ</td>
                                <td><i>ju</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('じゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>びゅ</td>
                                <td><i>byu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('びゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ぴゅ</td>
                                <td><i>pyu</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ぴゅ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                        </table>
                    </p>
                </div>)
                break;
            case 'ょ':
                explanation = (<div>
                    <p>This character looks like a smaller version of the よ (<i>yo</i>).</p>
                    <p>The よ (<i>yo</i>) sound gets combined with the preceding sound. It only ever follows sounds
                        ending in <i>i</i></p>
                    <p>This allows for the following combinations:
                        <table>
                            <tr>
                                <td>きょ</td>
                                <td><i>kyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('きょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>しょ</td>
                                <td><i>sho</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('しょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ちょ</td>
                                <td><i>cho</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ちょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>にょ</td>
                                <td><i>nyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('にょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ひょ</td>
                                <td><i>hyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ひょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>みょ</td>
                                <td><i>myo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('みょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>りょ</td>
                                <td><i>ryo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('りょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ぎょ</td>
                                <td><i>gyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ぎょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>じょ</td>
                                <td><i>jo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('じょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>びょ</td>
                                <td><i>byo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('びょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                            <tr>
                                <td>ぴょ</td>
                                <td><i>pyo</i></td>
                                <td><AudioButton
                                    onClick={() => Util.playSound('ぴょ', this.props.showLanguageError)}><Icon
                                    name={"caret square right"}/></AudioButton></td>
                            </tr>
                        </table>
                    </p>
                </div>)
                break;
            case 'ー':
                explanation = (<div>
                    <p>This new character is called <i>chōonpu</i>. It looks like a long dash</p>
                    <p>The chōonpu doubles the length of the preceding vowel.</p>
                </div>)
                break;
            default:
                explanation = (
                    <Explanation>
                    <span className="transliteration">{japanese.romanize(this.props.character)}
                        <AudioButton onClick={() => Util.playSound(this.props.character, this.props.showLanguageError)}><Icon
                            name={"caret square right"}/></AudioButton>
                    </span>
                    </Explanation>
                )
                break;
        }
        return (<div className="character">
                <Character>{this.props.character}</Character>
                {explanation}
            </div>
        )
    }
}

const Explanation = styled.div`
  font-size: 1.5em;
  line-height: 1.5em;
`;

const Character = styled.div`
  font-size: 2.5em;
  line-height: 2.5em;
`;



// WEBPACK FOOTER //
// ./src/components/QuizBox/CharacterExplanation.tsx